$('document').ready(function () {
    if (document.getElementById('profile') || document.getElementById('profile')) {

        var thankMessage = $(".successfulPayment");
        var notification_id;
        var allNotifications;

        function renderModal(result){
            var message = result[0].notification.message;
            notification_id = result[0].notification.id;
            thankMessage.text(message);
            $('#modalSuccessPayment').modal();
            allNotifications.splice(0, 1);
        }

        $.ajax({
                headers: {
                    'X-CSRF-TOKEN': window.Laravel.csrfToken
                },
                url: "/api/user/notification",
                data: [],
                dataType: 'json',
                type: 'POST'
            }
        ).done(function (result) {
            allNotifications = result.answer.notifications;
            if (allNotifications.length != 0) {
                renderModal(allNotifications)
            }
        });



        $('#modalSuccessPayment').click(function () {

            $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': window.Laravel.csrfToken
                    },
                    url: '/api/user/notification/close',
                    data: {
                        'id': notification_id
                    },
                    dataType: 'json',
                    type: 'POST'
                }
            ).done(function (result) {
                if(allNotifications.length!=0){
                    setTimeout(function() {
                        renderModal(allNotifications)}, 1500);

                }
            });
        });
    }
});

